// extracted by mini-css-extract-plugin
export var currencyInput = "_lp-1";
export var currencySymbol = "_lp-0";